import * as React from 'react';
import { Box, Typography } from '@mui/material';
import PriceCard, { PlanAction, PriceBlock } from './PlanCard';
import { MEMBERSHIP_MAPPING } from '../../../actions/types/users';
import { Membership } from '../../../actions/types/users';

export interface PriceCardProps {
    pageTitle: string
    actionTitle: string
    proAction: PlanAction
    eliteAction: PlanAction
}

const Plans: React.FunctionComponent<PriceCardProps> = ({ pageTitle, actionTitle, proAction, eliteAction }) => {
    return (
        <>
            <Box sx={{
                display: 'flex',
                flex: 1,
                padding: '5rem',
                position: 'relative',
                backgroundRepeat: 'no-repeat !important',
                backgroundSize: '100% 100% !important',
                backgroundPosition: 'top',
                background: `url(${require('../assets/waves.png')});`,
                backgroundColor: (theme) => theme.palette.background.level2,
            }}>
                <Typography sx={{
                            zIndex: 2,
                            marginBottom: 5,
                            font: (theme) => `normal normal bold ${theme.typography.pxToRem(88)}/${theme.typography.pxToRem(80)} Montserrat`
                        }}>{pageTitle}</Typography>
            </Box>
            <Box sx={{ 
                display: 'flex',
                padding: {
                    md: '2rem',
                },
                flexDirection: {
                    xs: 'column',
                    md: 'row',
                },
            }}>
                <PriceCard
                    sx={{ margin: 5 }}
                    cardColor={'#BBE8DA'}
                    title={MEMBERSHIP_MAPPING[Membership.PORTFOLIO_DESIGNER]}
                    target={`Easy-to-use research platform that helps advisors build robust portfolios.`}
                    price={<PriceBlock price={29.99}/>}
                    actionTitle={actionTitle}
                    features={[
                        'Powerful backtesting engine allows a full historical diagnosis of portfolios in just seconds.',
                        'Fund due diligence analytics allow a quick, in-depth comparison of different investments.',
                        'Easily import custom assets like SMAs and private investments.',
                        
                    ]}
                    action={proAction}
                />
                <PriceCard
                    sx={{ margin: 5 }}
                    cardColor={'#8EC8CA'}
                    title={MEMBERSHIP_MAPPING[Membership.ADVISOR_WORKSTATION]}
                    target={'Our end-to-end platform for managing client portfolios.'}
                    price={<PriceBlock price={99.99}/>}
                    actionTitle={actionTitle}
                    features={[
                        'Includes everything in our Model Portfolio Designer, enabling the scalable use of model portfolios across your client base.',
                        'A streamlined financial plan provides a simple yet transparent view of a client’s financial goals.',
                        'Sophisticated asset-liability matching engine quickly allocates a client’s wealth to Needs, Wants and Wishes portfolios that are intuitive to clients.',
                        'A modern, behavior-based risk profiling system ensures you implement investment strategies that your client can stick with.',
                    ]}
                    action={eliteAction}
                />
            </Box>
        </>
    )
}

export default Plans